var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 6.28529C16.9443 6.06267 16.6423 5.9376 16.3274 5.9376C16.0125 5.9376 15.7105 6.06267 15.4878 6.28529L9.60972 12.1634L3.73159 6.28529C3.50763 6.06898 3.20766 5.94928 2.8963 5.95199C2.58494 5.95469 2.2871 6.07958 2.06693 6.29975C1.84676 6.51993 1.72187 6.81777 1.71917 7.12913C1.71646 7.44048 1.83615 7.74045 2.05247 7.96441L8.77015 14.6821C8.99284 14.9047 9.29483 15.0298 9.60972 15.0298C9.9246 15.0298 10.2266 14.9047 10.4493 14.6821L17.167 7.96441C17.3896 7.74172 17.5146 7.43973 17.5146 7.12485C17.5146 6.80997 17.3896 6.50798 17.167 6.28529Z",
    fill: "#004A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowGreen);
export default __webpack_public_path__ + "static/media/IconArrowGreen.6466d8f5fd64f372d9675465a7a78865.svg";
export { ForwardRef as ReactComponent };